import { Core } from "@faire/design-tokens";
var primaryStyle = {
    active: function() {
        return {
            "background-color": Core.surface.enabled,
            color: Core.icon.inverse
        };
    },
    base: function() {
        return {
            "background-color": Core.surface.default,
            color: Core.icon.inverse
        };
    },
    disabled: function() {
        return {
            "background-color": Core.surface.disabled,
            color: Core.icon.disabled
        };
    },
    focus: function() {
        return {
            "background-color": Core.surface.hover,
            color: Core.icon.inverse
        };
    },
    hover: function() {
        return {
            "background-color": Core.surface.hover,
            color: Core.icon.inverse
        };
    },
    loading: function() {
        return {
            "background-color": Core.surface.default,
            color: Core.icon.inverse
        };
    }
};
var secondaryStyle = {
    active: function() {
        return {
            "background-color": Core.surface.inverse,
            border: "1px solid ".concat(Core.border.enabled),
            color: Core.icon.enabled
        };
    },
    base: function() {
        return {
            "background-color": Core.surface.inverse,
            border: "1px solid ".concat(Core.border.muted),
            color: Core.icon.default
        };
    },
    disabled: function() {
        return {
            "background-color": Core.surface.subdued,
            border: "1px solid ".concat(Core.border.disabled),
            color: Core.icon.disabled
        };
    },
    focus: function() {
        return {
            "background-color": Core.surface.inverse,
            border: "1px solid ".concat(Core.border.hover),
            color: Core.icon.hover
        };
    },
    hover: function() {
        return {
            "background-color": Core.surface.inverse,
            border: "1px solid ".concat(Core.border.hover),
            color: Core.icon.hover
        };
    },
    loading: function() {
        return {
            "background-color": Core.surface.inverse,
            border: "1px solid ".concat(Core.border.default),
            color: Core.icon.default
        };
    }
};
var tertiaryStyle = {
    active: function() {
        return {
            "background-color": Core.surface.subdued,
            color: Core.icon.enabled
        };
    },
    base: function() {
        return {
            "background-color": "transparent",
            color: Core.icon.default
        };
    },
    disabled: function() {
        return {
            "background-color": "transparent",
            color: Core.border.disabled
        };
    },
    focus: function() {
        return {
            "background-color": Core.surface.subdued,
            color: Core.icon.hover
        };
    },
    hover: function() {
        return {
            "background-color": Core.surface.subdued,
            color: Core.icon.hover
        };
    },
    loading: function() {
        return {
            "background-color": "transparent",
            color: Core.icon.default
        };
    }
};
export var iconWrapperTheme = {
    primary: primaryStyle,
    secondary: secondaryStyle,
    tertiary: tertiaryStyle
};
